var maxTimePeriods = 5;
var timeMap = {
    "1": new Date(2007, 0, 1),
    "2": new Date(2012, 0, 1),
    "3": new Date(2017, 0, 1)
};

var data_file = String(document.getElementById('condData').getAttribute('key'));
var data_string = String("./data/" + data_file + '.json');

var data_aux = require("./global_var");
var hyphen_data = data_aux.hyphenData;

// convert hyphen_data to dictionary
let hyphen_dict = {}
for (let i = 0; i < hyphen_data.length; i++) {
    hyphen_dict[hyphen_data[i].Condition] = hyphen_data[i].ConditionHyphen;
}
// console.log(hyphen_dict);

const {
    curr_survey,
    survey_dict
} = require("./survey_dict");

// get survey data in order to create download titles
let t1 = survey_dict[curr_survey].t1
let t2 = survey_dict[curr_survey].t2

// time period object consumed by clean_data_export.js column headers
let tObj = {
    T1: survey_dict[curr_survey].t1,
    T2: survey_dict[curr_survey].t2,
};

if(survey_dict[curr_survey].t3) {
   tObj.T3 = survey_dict[curr_survey].t3;
}

let currTitle = curr_survey.toUpperCase();

let sigFlagColumn = survey_dict[curr_survey].sigFlagColumn;

var {
    isExtraSmall,
    isSmall,
    isMedium,
    isLarge
} = require("./lib/breakpoints");
var makeTranslate = require("./lib/makeTranslate");
var debounce = require("./lib/debounce");
var classify = require("./lib/classify");
var formatStyle = require("./lib/formatStyle");
var export_data = require("./lib/export_data");
var saveAs = require('file-saver');
var cleanDataforExport = require('./lib/clean_data_export');

var d3 = {
    ...require("d3-axis/dist/d3-axis.min"),
    ...require("d3-scale/dist/d3-scale.min"),
    ...require("d3-selection/dist/d3-selection.min"),
    ...require("d3-shape/dist/d3-shape.min"),
    ...require("d3-collection/dist/d3-collection"),
    ...require("d3-textwrap/build/d3-textwrap.min"),
    ...require("d3-fetch/dist/d3-fetch")
};

// var fmtYearAbbrev = d => (d.getFullYear() + "").slice(-2);
var fmtYearFull = d => d.getFullYear();

var line = d3.line();

// #######

var labelColumn = "CatCondPL",
    ticksY = 3,
    numYears,
    time_periods = [];

//re-render chart on resize
window.addEventListener("resize", debounce(renderConditionChangeGraphic));

function renderConditionChangeGraphic() {

    d3.json(data_string).then(function (DATA) {

        // console.log('Data pre filter', DATA)
        // console.log("curr_survey", curr_survey);
        if(curr_survey === "nrsa1819"){
            DATA = DATA.filter(d=>d.Subpopulation.includes("NATIONAL"))
        } else {
            DATA = DATA.filter(d=>d.Subpopulation.includes("National"))
        }
        // console.log('Data post filter', DATA)

        // this is used later to alert the user if one of the indicators listed
        // in the text file is misspelled
        //Set finds the unique values in the array
        valid_indicators = [...new Set(DATA.map(d => {
            return d.IndicatorPL;
        }))];

        sortedData = d3.nest()
            .key(function (d) {
                return d.IndicatorPL;
            })
            .sortValues(function (a, b) {
                return (a.CatCondSort - b.CatCondSort);
            })
            .entries(DATA);

        sortedData = sortedData.map(function (d) {
            d.filteredValues = d.values.filter(function (j) {
                return j.CatCondBreakout == "Displayed";
            });
            return d;
        });


        var containers = document.querySelectorAll(".conditionChangeChartContainer");

        var totalChartHeight = 100,
            totalChartWidth = 250,
            chartWidth,
            chart_padding,
            domain,
            tick_values,
            numConds,
            betweenChartMargin = 0,
            barWidth,
            barGap = 2,
            valueGap = 6,
            numCols = 4;

        var margins = {
            top: 20,
            right: 35,
            bottom: 20,
            left: 37
        };

        if (isLarge.matches) {
            totalChartHeight = 130;
            betweenChartMargin = 0;
            barGap = 5;
            margins = {
                top: 20,
                right: 50,
                bottom: 20,
                left: 37
            };
        }

        // Calculate actual chart height
        var chartHeight = totalChartHeight - margins.top - margins.bottom;

        //clear for redraw
        var containerElements = d3.selectAll(containers);
        containerElements.html("");

        //START OF BREAKING UP BY INDICATOR //
        containerElements.each(function (d) {

            //get the width of the available space
            clientWidth = this.getBoundingClientRect().width;
            totalChartWidth = 0.8 * clientWidth; // leave space between charts

            /// CREATE DATA FOR EXPORT
            // determine the extent of the time periods and which time periods are used in the 
            // current data. ex/ T1 & T2 vs T2 & T3. This is used in determining 
            // the right columns to pull in the data export as well as having other functions later on.

            time_periods = [];

            // console.log('sortedData', sortedData);

            for (var i = 1; i < 4; i++) {
                if (sortedData[0].filteredValues[0][`Est.P.T${i}.Cond`]) {
                    time_periods.push(i);
                }
            }

            // console.log('condition.js_time_periods', time_periods);

            numYears = time_periods.length;

            var indicator = this.id;
            if (!valid_indicators.includes(indicator)) {
                return;
            } else {

                //console.log(indicator)
                var dataTemp = sortedData.filter(d => d.key == indicator)[0].filteredValues;
                var dataForExport = JSON.parse(JSON.stringify(dataTemp)); //needed to keep from mutating dataTemp
                //console.log('dtatemp', dataForExport);
                let changeGraphicTitle = this.parentNode.parentNode.childNodes[1].innerText;
                dataForExport = cleanDataforExport(dataForExport, 'change', indicator, time_periods, tObj);

                var chart_link = this.parentNode.nextElementSibling;

                d3.select(chart_link)
                    .selectAll("a.downloadLink")
                    .on('mouseover', (d) => {
                        d3.select(chart_link).select('a.downloadLink')
                            .attr('href', `${currTitle}_Change_Estimates_` +
                            indicator + `_${t1}-${t2}_National.csv`)  //this adds an address that will appear in the lower left corner on Chrome
                            .attr('title', '')  // this removes the "Data Download" tooltip on hover
                    })
                    .on('mouseout', (d) => {
                        d3.select(chart_link).select('a.downloadLink')
                        .attr('title', "Data Download"); // this replaces the "Data Download" title after hover
                    })
                    .on('click', (d) => {
                        var csv_blob = export_data(dataForExport, changeGraphicTitle, null, time_periods, tObj, 'change');
                        d3.select(chart_link).select('a.downloadLink')
                            .attr('href', null) //prevent reload on click
                            .style('color', '#5f4c95'); //this applies the visited color. For some reason, this wasn't working in css.

                            let downloadTitle = survey_dict[curr_survey]["changeDownloadTitle"].replace("Indicator", indicator);
                            downloadTitle = downloadTitle.replace(/ /g, "-");
                            saveAs(csv_blob, downloadTitle + ".csv");
                    });

                // SIGNIFICANCE
                var significant = false;
                for (var i = 0; i < dataTemp.length; i++) {
                    //instead of trying to figure out exactly which comparison we're looking for, 
                    // we just check all possible scenarios. This could probably be improved.
                    if (dataTemp[i][sigFlagColumn] == 'Y') {
                        significant = true;
                        break;
                    }
                }

                //check the significance and that a sig note isn't already there (needed for resizing)
                if (significant == true && this.parentNode.querySelectorAll('p.sigFlag').length == 0) {
                    d3.select(this.parentNode)
                        .append('p')
                        .attr('class', 'sigFlag')
                        .text(`*${survey_dict[curr_survey]['sig_note-change']}`);
                    
                    if(isExtraSmall.matches && curr_survey == "nrsa1819"){
                        d3.select(this).style('margin-bottom', '2.8rem');
                    }
                }
            }
        }); // end of containerElements.each

        // Create the root SVG elements.
        var chartWrappers = containerElements
            .append("div")
            .attr("class", "graphic-wrapper");

        var chartElements = chartWrappers
            .append("div")
            .style("width", "100%")
            .style("padding-left", margins.left + "px")
            .style("display", "flex")
            .style("justify-content", "flex-start");


        /// START DRAWING EACH INDIVIDUAL CHANGE CHART //
        chartElements.each(function (d) {
            // Get the current information in order to update the title/tooltip.
            const conditionChangeChartDiv = this.parentNode.parentNode.parentNode;
            const year = this.parentNode.parentNode.parentNode.previousElementSibling.previousElementSibling.innerText.match(/\(([^()]*)\)$/)[1]
            const indicator = this.parentNode.parentNode.id;

            // get the appropriate data for the current indicator and get the category condition plain language
            let data = sortedData.find(d => d.key == indicator).filteredValues
            let ccpl = [];
            data.forEach(function (d) {
                ccpl.push(`"${d.CatCondPL}"`);
            });
            ccpl = ccpl.filter((c) => c !== `"Not Assessed"`);
            if(ccpl.length < 3){
                ccpl = ccpl.join(' and ');
            }else{
                ccpl = ccpl.join(', ').replace(/,(?=[^,]*$)/, ', and');
            }
            // set the title attribute of the chart using the information above
            conditionChangeChartDiv.setAttribute(
                "title",
                `Bar graph showing change from ${year} for ${indicator}. Shows ${ccpl} condition, as well as percentage not assessed. ${survey_dict[curr_survey]['sig_note-change'].replace(".", "")}, if applicable.`
            );

             //update chart alt text with correct indicator name and year
             conditionChangeChartDiv.setAttribute("alt", `Graph of change in ${indicator} condition from ${survey_dict[curr_survey].t1} to ${survey_dict[curr_survey].latest_year}`);

            // console.log('this', this)
            var chartContainer = d3.select(this);

            let curr_indicator = d3.select(this.closest(".conditionChangeChartContainer")).attr("id");
            if (!valid_indicators.includes(curr_indicator)) {
                d3.select(this)
                    .append("text")
                    .text('THE INDICATOR DATA_KEY DOES NOT MATCH THE DATA FILE');
            } else {
                chart = chartContainer
                    .selectAll(".conditionGroups")
                    .data(function (d) {
                        //var indicator = d3.select(this.closest(".conditionChangeChartContainer")).attr("id");
                        // console.log('indicator', indicator)
                        var data = sortedData.filter(d => d.key == curr_indicator)[0].filteredValues;
                        // console.log('data', data)
                        // numYears = (!isNaN(data[0][T1_column]) && !isNaN(data[0][T2_column]) && !isNaN(data[0][T3_column])) ? 3 : 2;
                        numConds = data.length;
                        // console.log('num conds', numConds);
                        chartWidth = totalChartWidth / numConds;
                        //space extending the xaxis on either side of each chart
                        chart_padding = (numYears > 2) ? chartWidth * 0.2 : chartWidth * 0.3; 
                        // console.log(chart_padding);
                        barWidth = (isExtraSmall.matches) ? chartWidth / 4 : (chartWidth / numYears) * 0.7;
                        return data;
                    })
                    .enter()
                    .append("svg");

                // console.log('chart', chart.nodes())
                // console.log('chart width', chartWidth)
                // console.log('barWidth', barWidth)
                chart
                    .attr("overflow", "visible")
                    .attr("class", d => `conditionGroup ${classify(d.CatCondColor)}`)
                    .attr("id", d => classify(d[labelColumn]))
                    .attr("height", chartHeight)
                    .attr("width", chartWidth)
                    .attr('x', (d, i) => chartWidth * i);


                // console.log("chart", chart.node())

                // Create D3 axes.
                if (numYears == 3) {
                    tick_values = [1, 2, 3];
                    domain = [1, 3];
                } else {
                    tick_values = time_periods;
                    domain = time_periods;
                }

                //set dynamically if we want to maximize bar size
                var min = 0;
                var max = 100;

                var yScale = d3
                    .scaleLinear()
                    .domain([min, max])
                    .range([chartHeight, 0]);

                var yAxis = d3
                    .axisLeft()
                    .scale(yScale)
                    .ticks(ticksY)
                    .tickFormat(function (d) {
                        return d.toFixed(0) + "%";
                    });

                var xScale = d3
                    .scaleLinear()
                    .domain(domain)
                    .range([chart_padding * 0.8, chartWidth - chart_padding]);
                // the 0.8 is there because without it there is slightly more space on the axis
                // to the left of the farthest left bar. Not sure why that is, but this fixes it.

                let wrap_x_axis = d3.textwrap().bounds({
                    width: chartWidth/5,
                    height: 30
                });

                var xAxis = d3
                    .axisBottom()
                    .scale(xScale)
                    .tickValues(tick_values)
                    .tickFormat(function (d, i) {
                        return survey_dict[curr_survey].axis_labels[i];
                    });



                // Render axes to chart.
                chart
                    .append("g")
                    .attr("class", "x axis")
                    .attr("transform", makeTranslate(0, chartHeight))
                    .call(xAxis);
                
                // the two years of the nrsa survey require the axis labels to be wrapped on xsmall screens
                // to avoid complication, we only do this for nrsa
                if(isSmall[0].matches && curr_survey == "nrsa1819") {
                    chart
                        .selectAll(".x.axis text")
                        .call(wrap_x_axis);

                    d3.selectAll(".x.axis foreignObject")
                        .attr('x', -5)
                        .style('line-height', '1')
                        .style('text-align', 'left');
                }


                chart.filter(function (d, i) {
                        var first = i == 0;
                        // console.log(first);
                        return first;
                    })
                    .append("g")
                    .attr("class", "y axis changeText")
                    .attr("transform", makeTranslate(-10, 0))
                    .call(yAxis);

                // Render grid to chart.
                var yAxisGrid = function () {
                    return yAxis;
                };

                chart
                    .append("g")
                    .attr("class", "y grid")
                    .attr("transform", makeTranslate(-3, 0))
                    .call(
                        yAxisGrid()
                        .tickSize(-chartWidth, 0, 0)
                        .tickFormat("")
                    );

                    // define the size of the Foreign object created by d3-textwrap
                if (isExtraSmall.matches || (isSmall[0].matches && isSmall[1].matches)) {
                    if (isSmall[1].matches) { //isSmall
                        wrap_height = 40;
                        wrap_width = chartWidth;
                    } else { //isExtraSmall
                        wrap_height = 35;
                        wrap_width = chartWidth * 0.95;
                    }
                    var wrap = d3.textwrap().bounds({
                        width: wrap_width,
                        height: wrap_height
                    });


                    //Add condition category titles
                    labels = chart
                        .append("g")
                        .attr("class", "labels change_label_area");

                    // ############
                    labels.append('text')
                        .text(d => {
                            let sig = d[sigFlagColumn];

                            if (sig == 'Y') {
                                return hyphen_dict[d[labelColumn]] + '*';
                            } else {
                                return hyphen_dict[d[labelColumn]];
                            }
                        })
                        .attr('class', 'change_column_labels')
                        .attr("x", chartWidth / 2 - 5);
                    
                    // instigate the wrapping
                    d3.selectAll('.change_column_labels').call(wrap);

                } else {

                    chart
                    .append("text")
                    .attr("class", "labels")
                    .text(d => {
                        let sig = d[sigFlagColumn];

                            if (sig == 'Y') {
                                return d[labelColumn] + '*';
                            } else {
                                return d[labelColumn];
                            }
                        })
                        .attr("text-anchor", "middle")
                        .attr("x", chartWidth / 2 - 3)
                        .attr("y", -25);
                }

                //Render bars to chart.
                var changeBars = chart
                    .append("g")
                    .attr("class", "bars")
                    .selectAll("rect")
                    .data(function (d) {
                        var values = [];
                        for (var t = 1; t <= maxTimePeriods; t++) {
                            if (!isNaN(d[`Est.P.T${t}.Cond`])) {
                                values.push({
                                    //time: timeMap[t],
                                    time: t,
                                    barValue: Number(d[`Est.P.T${t}.Cond`]),
                                    rangeStartValue: Number(d[`LCB.P.T${t}.Cond`]),
                                    rangeEndValue: Number(d[`UCB.P.T${t}.Cond`])
                                });
                            } else if ((d[`Est.P.T${t}.Cond`]) === "NA") {
                                values.push({
                                    //time: timeMap[t],
                                    time: t,
                                    barValue: 0,
                                    rangeStartValue: 0,
                                    rangeEndValue: 0
                                });
                            }
                        }
                        return values;
                    })
                    .enter();

                changeBars
                    .append("rect")
                    .attr("x", (d) => numConds > 3 ? xScale(d.time) - barWidth / 2 : xScale(d.time) - (barWidth) / 2)
                    .attr("width", d => numConds >= 3 ? barWidth : barWidth * 1.5)
                    .attr("y", d => d.barValue >= 0 ? yScale(d.barValue) : yScale(0))
                    .attr("height", d => Math.abs(yScale(0) - yScale(d.barValue)));

                changeBars
                    .append('rect')
                    .attr('class', 'changeRange')
                    .attr('x', d => xScale(d.time) - barWidth / 16)
                    .attr('width', barWidth / 11)
                    .attr('y', d => yScale(d.rangeEndValue))
                    .attr('height', d => {
                        if (d.rangeStartValue != 'NaN' && !isNaN(d.rangeStartValue)) {
                            return d.rangeEndValue - d.rangeStartValue;
                        }
                    });


                // Render bar values.
                chart
                    .append("g")
                    .attr("class", "value")
                    .selectAll("text")
                    .data(function (d) {
                        var values = [];
                        for (var t = 1; t <= maxTimePeriods; t++) {
                            if ((d[`Est.P.T${t}.Cond`]) === "NA") {
                                values.push({
                                    // time: timeMap[t],
                                    time: t,
                                    value: "NA",
                                    rangeEndValue: "NA",
                                });
                            } else if (!isNaN(d[`Est.P.T${t}.Cond`])) {
                                values.push({
                                    // time: timeMap[t],
                                    time: t,
                                    value: Number(d[`Est.P.T${t}.Cond`]),
                                    rangeEndValue: Number(d[`UCB.P.T${t}.Cond`])
                                });
                            }
                        }
                        return values;
                    })
                    .enter()
                    .append("text")
                    .attr("class", "changeText")
                    .attr("year", d => fmtYearFull(timeMap[d.time]))
                    .text(function (d) {
                        if (d.value > 0 && d.value < 1 && d.value > 0.5) {
                            return "1%";
                        } else if (d.value > 0 && d.value < 0.5) {
                            return "<1%";
                        } else if (d.value === "NA") {
                            return "N/A";
                        } else {
                            return d.value.toFixed(0) + "%";
                        }
                    })
                    .attr("text-anchor", "middle")
                    .attr("x", (d) => xScale(d.time))
                    .attr("y", d => d.rangeEndValue > 0 ? yScale(d.rangeEndValue) : yScale(0))
                    .attr("dx", 2)
                    .attr("dy", -4);
            }
        }); // end of chartElements.each

        /// D3-wrap takes the text and adds it to a div within a Foreign object. The size of the Foreign Object is 
        // set when the wrap is defined (around 422)


        if (isExtraSmall.matches || (isSmall[0].matches && isSmall[1].matches)) {
            // locate the foreign object
            d3.selectAll('.change_label_area foreignObject')
                .style('text-align', 'center')
                .style('position', 'fixed')
                .attr('x', isExtraSmall.matches ? chartWidth * (-0.05 / 2) : 0) //centers label over the chart
                .attr('y', -52);


            var text_divs = d3.selectAll('.change_label_area foreignObject div');

            // size and locate the inner div
            text_divs.nodes().forEach(element => {
                var width = element.parentNode.getAttribute('width');
                d3.select(element)
                    .style('height', wrap_height + "px")
                    .style('width', d => {
                        return width + 'px';
                    })
                    .style('display', 'table-cell')
                    .style('vertical-align', 'bottom');
            });
        }
        // 


        //   //////add annotations//////////

        //add arrow marker
        // chartElements.append("defs").html(`<marker id="arrow" viewBox="0 0 10 10" refX="5" refY="5"
        //     markerWidth="6" markerHeight="6"
        //     orient="auto-start-reverse">
        //   <path fill="#289426" d="M 0 0 L 10 5 L 0 10 z" />
        // </marker>`);

        changeSVGs = containerElements.selectAll('svg');

        changeSVGs.each(function (d) {
            svg = d3.select(this);

            if ((!d3.select(this.closest(".conditionChangeChart")).select(".changeAnnotation").empty())) {
                if (d3.select(this.closest(".conditionChangeChart")).select(".changeAnnotation").attr('id') ==
                    svg.node().getAttribute('id')) {

                    var annotationValue = classify(d3.select(this.closest(".conditionChangeChart")).select(".changeAnnotation").attr("id"));
                    var targetConditionGroup = d3.select(this.closest(".conditionChangeChart")).select(`svg#${annotationValue}`);

                    //get the leftmost x value from the transform value of the leftmost tick
                    var farleftnode = targetConditionGroup.select('.x').select(":nth-child(2)"),
                        farleftX = farleftnode.node().transform.baseVal[0].matrix.e;

                    //get the rightmost x value from the transform value of the leftmost tick
                    var farrightnode = targetConditionGroup.select('.x').select(":nth-child(3)"),
                        farrightX = farrightnode.node().transform.baseVal[0].matrix.e;

                    //check and add annotations
                    var bracket = svg
                        .append("g")
                        .attr("class", "annotationGroup")
                        .attr("id", function (d) {
                            var annotation = d3.select(this.closest(".conditionChangeChart")).select(".changeAnnotation").attr("id");
                            return classify(annotation);
                        })
                        // .attr("year", function(d){
                        // 	return d3.select(this.closest(".conditionChangeChart")).select(".changeAnnotation").attr("year");
                        // })
                        .append("path")
                        .attr("class", "annotationLine")
                        .attr('shape-rendering', 'crispEdges')
                        .attr("d", function (d) {
                            var x1 = farleftX;
                            var y1 = chartHeight + 20;

                            var x2 = x1;
                            var y2 = y1 + 10;

                            var x3 = farrightX;
                            var y3 = y2;

                            var x4 = x3;
                            var y4 = y1;

                            var lineCoords = [
                                [x1, y1],
                                [x2, y2],
                                [x3, y3],
                                [x4, y4]
                            ];

                            return line(lineCoords);
                        });

                    //vertical line from bracket
                    svg.append('g')
                        .attr('class', 'annotationGroup')
                        .append('path')
                        .attr("class", "annotationLine")
                        .attr('d', function (d) {
                            var xVal = (farleftX + farrightX) / 2;
                            y1 = chartHeight + 30;
                            y2 = chartHeight + 52;

                            var lineCoords = [
                                [xVal, y1],
                                [xVal, y2]
                            ];
                            return line(lineCoords);
                        });
                }
            }


        });
    });
}

renderConditionChangeGraphic();